export const flightInformationHeader = [
  'From City',
  'To Country',
  'To City',
  'Date',
  'Departure Time',
  'Preferred Airline',
  'Class',
];

export const hotelInformationHeader = [
  'Country',
  'Place',
  'Hotel Name',
  'Check-in Date',
  'Check-out Date',
  'Client',
];

export const approvalsActions = {
  Approve: 'A',
  Reject: 'R',
};
